module.exports = __webpack_public_path__ + "static/media/hand-left-back.e9ad286c.png";